//converts date to YYYY-MM-DD format
export function toYMD(d) {
  const date = new Date(d);
  if (date.toString() === "Invalid Date") return "";
  return [
    date.getFullYear(),
    (date.getMonth() + 1).toString().padStart(2, "0"),
    date.getDate().toString().padStart(2, "0"),
  ].join("-");
}

//converts date to DD-MM-YYYY format
export function toDMY(d) {
  const date = new Date(d);
  if (date.toString() === "Invalid Date") return "";
  return [
    date.getDate().toString().padStart(2, "0"),
    (date.getMonth() + 1).toString().padStart(2, "0"),
    date.getFullYear(),
  ].join("-");
}

export function dateTime(date) {
  const d = new Date(date);
  if (d.toString() === "Invalid Date") return "";
  return new Intl.DateTimeFormat("en-IN", {
    day: "numeric",
    month: "long",
    hour: "numeric",
    minute: "numeric",
  }).format(d);
}

export function toDateOnly(date) {
  const d = new Date(date);
  if (d.toString() === "Invalid Date") return "";
  return new Intl.DateTimeFormat("en-IN", {
    year: "numeric",
    day: "numeric",
    month: "long",
  }).format(d);
}

export function elapsedTime(time) {
  time = new Date(time);
  const now = new Date();
  const elapsed = now - time;

  const seconds = Math.floor(elapsed / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (days >= 30) return dateTime(time);
  if (days >= 1) return `${days} ${days == 1 ? "day" : "days"} ago`;
  if (hours >= 1) return `${hours} ${hours == 1 ? "hour" : "hours"} ago`;
  if (minutes >= 1) return `${minutes} ${minutes == 1 ? "minute" : "minutes"} ago`;
  return `now`;
}
